import * as _ from 'underscore';

import { ISelectFilterDefinitionOption } from '~content/services/FilterPanelService';

import { SiteRoleOptionsResource } from '../../userManagement/services/resources/SiteRoleOptions';
import { SiteRolesResource } from '../../userManagement/services/resources/SiteRoles';
import { SiteRoles } from '../ServerApi/types/ISiteRole';

export module SiteRoleFilterHelper {

  export const AnyRole = SiteRolesResource.AnyRole;

  export function siteRoleOptions(roles: string[],userCountsByRole?: _.Dictionary<number>) {

    if (!userCountsByRole) {
      userCountsByRole = {};
    }

    const options: ISelectFilterDefinitionOption<string>[] = [
      {
        value: AnyRole,
        translate: 'siteRole_Any',
        count: userCountsByRole[AnyRole]
      }
    ];

    _.each(roles, (role: string) => {
      if ((role !== SiteRoles.SupportUser) || userCountsByRole[role] > 0) {
        options.push({
          value: role,
          translate: SiteRoleOptionsResource.instance.getSiteRoleLockey(role),
          count: userCountsByRole[role]
        });
      }
    });

    return options;
  }

}
